module.exports = __webpack_public_path__ + "static/media/traycorp10.c923854d.png";